<template>
  <div class="table-search-form-main" :class="{
    entype: lang != 'zh',
  }">
    <div class="table-search-form-flex label-type">
      <div class="table-search-form-label">
        <i v-if="required" :style="{color: 'red'}">*</i>
        {{label}}
      </div>
    </div>
    <div  class="table-search-form-flex">
      <div v-if="!custom" class="table-search-form-box">
        <slot></slot>
        <!-- <el-input v-model="searchForm.user_id" :placeholder="$I18n('user_reg_acc_02')"/> -->
      </div>
      <slot v-else></slot>
    </div>
  </div>
</template>
<script>
export default {
  props:["label", "required", "custom"],
  data(){
    return {
      lang: "zh",
    }
  },
  mounted: function(){
    this.lang = this.$router.history.current.query.lang;
  },
}
</script>
<style lang="css" scoped>
  .table-search-form-flex.label-type{
    min-width: 100px;
    max-width: 100px;
  }
  .table-search-form-main{
    margin-bottom: 16px;
    width: 450px;
  }
  .table-search-form-main.entype{
    width: 550px;
  }
  .entype .table-search-form-flex.label-type{
    min-width: 200px;
    max-width: 200px;
  }
</style>